import React from 'react';
import { Card, CardContent, Typography, Box, Button, LinearProgress } from '@mui/material';
import { Trophy } from 'lucide-react';

const BuyerStatusCard = () => {
  const jp = 62480;
  const target = 100000;
  const progress = (jp / target) * 100;
  return (
    <Card className="buyer-status-card">
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <Trophy size={28} style={{ color: '#D4AF37' }} />
          <Typography variant="h5" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            DIAMOND BUYER
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {jp.toLocaleString()} JP
          </Typography>
        </Box>
        <LinearProgress variant="determinate" value={progress} sx={{ height: 8, borderRadius: 4, mb: 1 }} />
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
            {jp.toLocaleString()} / {target.toLocaleString()} JP
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
            {Math.round(progress)}%
          </Typography>
        </Box>
        <Typography variant="subtitle2" sx={{ mt: 1, fontWeight: 600 }}>
          {target - jp} JP to Elite
        </Typography>
        <Box mt={2} display="flex" gap={2}>
          <Button variant="contained">View Benefits</Button>
          <Button variant="outlined">How Rewards Work</Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BuyerStatusCard;